import React, { useEffect } from "react";
import "./App.css";
import {
  GlobalFooter,
  LocationBar,
  UtilityHeader,
  SettingsBar,
  Branding,
  MobileControls,
  Navigation,
} from "./components/ssi";
import { AlertBanner } from "./components/shared";
import { Routing } from "./routing";
import axios from "axios";
import { useAlertBanner, useHasUserAgrmt, useIsBulkManifest } from "./hooks";
import { UserAgrmtModal } from "./components/pages/landing-page";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import {
  ReactPlugin,
  withAITracking,
} from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";
import { MsalWrapper, MsalWrapperContext } from "./redux/actions/authActions";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";

ReactGA.initialize(process.env.REACT_APP_GA_TRACKER_ID);
const browserHistory = createBrowserHistory({ basename: "" });
browserHistory.listen(() => {
  ReactGA.pageview(window.location.pathname + window.location.search);
});

const {
  REACT_APP_DTSC_API_URL,
  REACT_APP_INSTRUMENTATION_KEY
} = process.env;

var reactPlugin = new ReactPlugin();
var appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: REACT_APP_INSTRUMENTATION_KEY,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
  },
});

appInsights.loadAppInsights();
appInsights.trackPageView();

axios.defaults.baseURL = REACT_APP_DTSC_API_URL;

// Add a request interceptor
axios.interceptors.request.use(
  function (config) {
    if (REACT_APP_DTSC_API_URL === config.baseURL) {
      config.headers.Authorization = `Bearer ${localStorage.getItem(
        "msal.idtoken"
      )}`;
      config.headers["Ocp-Apim-Subscription-Key"] = '';
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

const msalWrapper = new MsalWrapper(process.env);

function App() {
  const alerts = useAlertBanner();
  const dispatch = useDispatch();
  let location = useLocation();
  const hasUserAgrmt = useHasUserAgrmt();
  const isBulkManifest = useIsBulkManifest();
  const user = useSelector((state) => state.user);


  useEffect(() => {
    dispatch(msalWrapper.fetchUser());
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <div>
      <MsalWrapperContext.Provider value={msalWrapper}>
        <header role="banner" id="header" className="global-header fixed">
          <div id="skip-to-content">
            <a href="#main-content">Skip to Main Content</a>
          </div>
          {location.pathname === "/" &&
            alerts.map((alert) => {
              if (alert.link === "/" || alert.link === "" || alert.link === null) {
                return <AlertBanner alert={alert} key={alert.id} />
              }
              return ""; // return nothing
            })
          }
          <LocationBar />
          <UtilityHeader />
          <SettingsBar />
          <Branding />
          <MobileControls />
          {(user.isAuth && hasUserAgrmt === false && !isBulkManifest) &&
            <UserAgrmtModal hasUserAgrmt={useHasUserAgrmt} />
          }
          <div className="navigation-search">
            <Navigation />
            <div id="head-search" className="search-container">
              {/* <!--#include virtual="/ssi/search.html" --> */}
            </div>
          </div>
        </header>
        <div id="main-content" className="main-content">
          <Routing />
        </div>
        <GlobalFooter />
      </MsalWrapperContext.Provider>
    </div>
  );
}
export default withAITracking(reactPlugin, App);
